<template>
  <div class="top-menu">
    <a :href="donateUrl" target="_blank" class="top-menu__link">
      {{ donateLabel }}
    </a>

    <button
      type="button"
      class="top-menu__item"
      :title=searchLabel
      @click="openSearch"
      @keyup.enter="openSearch"
    >
      <SearchIcon />
    </button>

    <button
      type="button"
      class="top-menu__item"
      :title=menuLabel
      @click="openNavigation"
      @keyup.enter="openNavigation"
    >
      <BurgerIcon />
    </button>
  </div>
</template>

<style  lang="scss">
@import "../scss/importall.scss";

.top-menu {
  display: flex;
  align-items: center;
  user-select: none;
}

.top-menu__item {
  padding: 0.5rem;
  color: inherit;
  cursor: pointer;
  width: 4rem;
  height: 4rem;
  transition: all 0.15s ease-in-out;

  &:hover {
    opacity: 0.6;
  }

  @include mq-tablet {
    width: 3rem;
    height: 3rem;
  }
}

.top-menu__link {
  @extend %text;
  margin-right: 0.5rem;

  color: inherit;
  text-decoration: none;
  transition: all 0.15s ease-in-out;
  border-bottom: 0.1rem solid transparent;

  &:hover {
    border-color: currentColor;
  }
}
</style>
<script>
import focusTrap from "./utils/focusTrap.js";
import BurgerIcon from "./NavigationOverlay/BurgerIcon.vue";
import SearchIcon from "./Icons/SearchIcon.vue";

export default {
  components: {SearchIcon, BurgerIcon},
  mounted() {
    focusTrap();
  },
  props: {
    donateUrl: {
      type: String,
      default: null,
    },
    donateLabel: {
      type: String,
      default: null,
    },
    searchLabel: {
      type: String,
      default: null,
    },
    menuLabel: {
      type: String,
      default: null,
    },
  },
  methods: {
    // using custom events here as we are in custom elements mode and not a full vue app
    openSearch() {
      const catFound = new CustomEvent("openSearch");
      document.dispatchEvent(catFound);
    },
    openNavigation() {
      const catFound = new CustomEvent("openNavigation");
      document.dispatchEvent(catFound);
    },
  },
};
</script>
